/*
 * @Author: weichun.pwc
 * @Date: 2019-10-12 11:37:49
 * @LastEditors: weichun.pwc
 * @LastEditTime: 2019-10-13 23:26:31
 * @Description: util
 */
var noop = function noop() {// do nothing ...
};

var util = {
  noop: noop,
  win: typeof window === 'object' && window.document ? window : undefined,

  /**
   * get object type or is typeof xxx
   * @param  {*} obj
   * @param  {String} [type]
   * @return {String|Boolean}
   */
  T: function T(obj, type) {
    var t = Object.prototype.toString.call(obj).substring(8).replace(']', '');
    return type ? t === type : t;
  },

  /**
   * 事件绑定
   * @param  {DOM}   target
   * @param  {String}   type
   * @param  {Function} callback
   * @param  {Boolean}  isOnce
   * @param  {Boolean} useCapture
   * @return {Object} this
   */
  on: function on(target, type, callback, isOnce, useCapture) {
    if (target.addEventListener) {
      useCapture = useCapture ? useCapture : false;
      target.addEventListener(type, function __fn(e) {
        isOnce && target.removeEventListener(type, __fn, useCapture);
        callback.call(this, e);
      }, useCapture);
    } else if (target.attachEvent) {
      target.attachEvent('on' + type, function __fn(e) {
        isOnce && target.detachEvent('on' + type, __fn);
        callback.call(this, e);
      });
    }

    return this;
  },

  /**
   * 事件解绑
   * @param  {DOM}   target
   * @param  {String}   type
   * @param  {Function} callback
   * @return {Object} this
   */
  off: function off(target, type, callback) {
    if (!callback) return this;

    if (target.removeEventListener) {
      target.removeEventListener(type, callback);
    } else if (target.detachEvent) {
      target.detachEvent(type, callback);
    }

    return this;
  }
}; // -- util END

export default util;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-jserror@1.0.13@@ali/aes-tracker-plugin-jserror/es/utils/util.js
// module id = null
// module chunks = 